<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uSPvs1/cover.jpeg?1728169434084" alt="This image is the cover for the book Dead Goes the Neighbourhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Goes the Neighbourhood
      </h1>
      <p class="bookDescription body article font2">
        <p>A baffling murder mystery consumes the town of Muriel which is situated ‘next door’ to infamous Brumby Flat, South Australia where wild rumours fly as high as the travelling circus trapeze and romantic betrayal threatens to overwhelm the residents of both towns. Senior Detective Phillip Duncan reluctantly returns to town, called in to investigate the murders of two seemingly unrelated individuals in the region he knows all too well. Some old characters return, and some surprising new romances blossom while others fade out for good. When a travelling circus rolls into town, expect a climatic showdown with plenty of sequins, sparkles and spandex in the mix. Raquel Willaston is lured back into performing on the high trapeze. But very quickly, she realises that everyone working under this big top has their own secret agenda to hide. Will this prove to be Detective Duncan’s last case, as another dangerous serial killer closes in, intent to cover up their bloody trail?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Portia Stanton-Noble
      </h2>
      
      <p class="authorDescription body article">Born in Melbourne, Victoria, Portia Stanton-Noble currently lives in the Gilbert Valley, South Australia in her private hotel with her son. When she was eight years old, she had already made up her mind that she was going to be a writer. This novel is the fourth and final instalment of the series, following The Big Dead Dry, Pretty Dead Ordinary and Drop Dead Like Flies. Since completing the murder mysteries and romantic intrigues surrounding her characters in the fictional township of Brumby Flat, she has been busy researching material for her next books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69cc903a